<template>
    <div class="build-step create-ad-display-log-for-premium-listing">
        <div class="title">
            <div class="move-handle">
                <icon type="dots-vertical" size="24px" />
            </div>
            <div class="name">Create Ad Display Log for PL</div>
            <delete-action text rounded icon="close" message="Are you sure you want to remove this build step?"
                tooltip="Remove Build Step" @delete="removeBuildStep" />
        </div>
        <div class="description">
            Create an AdDisplayLog for the premium listing ad when the winning campaign has PL enabled. This step must
            come after the "Reply with Auction Result" step.
        </div>
    </div>
</template>

<script>
import deleteAction from '@/components/widgets/DeleteAction.vue';

export default {
    name: 'CreateAdDisplayLogForPremiumListing',
    emits: ['remove'],
    components: {
        deleteAction,
    },
    methods: {
        removeBuildStep() {
            this.$emit('remove');
        },
    },
};
</script>
